<template>
  <div class="container">
    <div class="have-equipment">
      <!-- <nav-bar @leftClick="leftClick" rightName="添加" @rightClick="rightClick"></nav-bar> -->
      <div class="unit-container">
        <equipment-unit
          v-for="(item, i) in equipmentsData"
          :key="item.id"
          :equipNUmber="item.name"
          :active="item.active"
          :deviceid="item.id"
          :deviceName="item.name"
          :index="i"
          :deviceidEx="item.device_id_ex"
          @btnClick="btnClick"
          @unitClick="unitClick">
        </equipment-unit>
        <button class="btn-block btn-save" @click="rightClick">添加</button>
      </div>
    </div>
    <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure" :text="text" :rightName="btnName"></ttip-select>
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import EquipmentUnit from './components/EquipmentUnit.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import axios from 'axios'
import Common from '../../assets/js/common.js'
var isLocal = Common.getEvn()
var api = process.env.BASE_URL
export default {
  components: {
    NavBar,
    EquipmentUnit,
    TtipSelect
  },
  data () {
    return {
      equipmentsData: [],
      userId: localStorage.getItem('max_userId'),
      deviceId: localStorage.getItem('max_device_id'),
      deviceIdB: null,
      deviceIdEXB: null,
      showSelectTip: false,
      deleteId: null,
      spliceIndex: null,
      mode: 'delete',
      text: '“该设备的设置信息将被删除，且不可恢复。 确定删除？”',
      btnName: '确定'
    }
  },
  methods: {
    leftClick () {
      this.$router.back(-1)
    },
    rightClick () {
      this.$router.push({path: '/StepOne'})
    },
    getEquipmentList () {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中',
        mask: true
      })
      this.toast.show()
      if (isLocal === 'local') {
        axios.get('/Calendar/api/device/get/device/list/?user_id=' + this.userId)
        .then(this.getEquipmentListSucc)
        .catch(this.getEquipmentListError)
      } else {
        axios.get(api + '/Calendar/api/device/get/device/list/?user_id=' + this.userId)
        .then(this.getEquipmentListSucc)
        .catch(this.getEquipmentListError)
      }
    },
    getEquipmentListSucc (res) {
      this.toast.hide()
      let _res = res.data
      if (_res.result === 0) {
        let datas = _res.data_latest
        // console.log("列表信息------->>>>" + JSON.stringify(datas))
        if (datas.length > 0) {
          for (let i = 0, len = datas.length; i < len; i++) {
            if (datas[i].id === Number(this.deviceId)) {
              datas[i].active = true
              // localStorage.setItem('max_device_id_ex', datas[i].device_id_ex)
            } else {
              datas[i].active = false
            }
          }
          this.equipmentsData = datas
          // console.log('equipmentsData---->>>' + JSON.stringify(this.equipmentsData))
        } else {
          this.$router.push({path: '/', query: {formPage: 'equipment'}})
        }
      }
    },
    getEquipmentListError () {
      this.toast.hide()
      // Common.toast(this, '调用接口失败！获取设备列表出错')
    },
    cancel () {
      this.showSelectTip = false
    },
    sure () {
      if (this.mode === 'cut') {
        localStorage.setItem('max_device_id', this.deviceIdB)
        this.$router.push({path: '/', query: {formPage: 'equipment', equipmentId: this.deviceId}})
      } else {
        this.Untied(this.deleteId)
      }
      this.showSelectTip = false
    },
    Untied (id) {
      this.toast = this.$createToast({
        time: 0,
        txt: '加载中',
        mask: true
      })
      this.toast.show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/device/Untied/', {
          'user_id': this.userId,
          'device_id': id
        })
        .then(this.UntiedSucc)
        .catch(this.UntiedError)
      } else {
        axios.post(api + '/Calendar/api/device/device/Untied/', {
          'user_id': this.userId,
          'device_id': id
        })
        .then(this.UntiedSucc)
        .catch(this.UntiedError)
      }
    },
    UntiedSucc (res) {
      this.toast.hide()
      let _res = res.data
      if (_res.result === 0) {
        // this.getEquipmentList()
        this.equipmentsData.splice(this.spliceIndex, 1)
        this.showTips()
        if (this.deleteId === Number(this.deviceId)) {
          let dataLen = this.equipmentsData.length
          if (dataLen > 0) {
            this.$forceUpdate()
            this.$set(this.equipmentsData[dataLen - 1], 'active', true)
            localStorage.setItem('max_device_id', this.equipmentsData[dataLen - 1].id)
          } else {
            this.$router.push({path: '/', query: {formPage: 'equipment'}})
          }
        }
      } else {
        this.toast = this.$createToast({
          txt: _res.message,
          type: 'txt'
        }).show()
      }
    },
    UntiedError () {
      this.toast.hide()
      // Common.toast(this, '调用接口失败！获取设备列表出错')
    },
    unitClick (id, exId) {
      // let name = 8 * Math.pow(10, 7) + id
      let name = exId
      this.mode = 'cut'
      this.btnName = '切换'
      this.text = '选择设备(' + name + ')，确定切换为默认设备？'
      if (id !== Number(this.deviceId)) {
        // console('111111' + name)
        this.deviceIdB = id
        this.showSelectTip = true
      } else {
        this.$router.push({path: '/', query: {formPage: 'equipment', equipmentId: id}})
      }
    },
    btnClick (id) {
      // console.log(id)
      this.mode = 'delete'
      this.btnName = '确定'
      this.text = '“该设备的设置信息将被删除，且不可恢复。 确定删除？”'
      this.deleteId = id.deviceid
      this.spliceIndex = id.index
      this.showSelectTip = true
    },
    showTips () {
      let url = location.href.split('#')[0]
      this.$createDialog({
        type: 'alert',
        content: '解绑日历无法清除日历上的某些个人数据（如自定义事件），如您想彻底清除，请重置日历。<a href="' + url + '#/Question?a=1">如何重置？</a>'
      }).show()
    }
  },
  beforeMount () {
    // sessionStorage.setItem('isfirst', 'no')
    Common.setTitle('设备列表')
    this.getEquipmentList()
  },
  activated () {
    this.getEquipmentList()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
  .unit-container
    height 83vh
    padding-top 20px;
    overflow-y auto;
    .equipment-unit
      margin 0 auto 15px
</style>



// WEBPACK FOOTER //
// src/pages/EquipmentList/EquipmentList.vue